import { Injectable } from '@angular/core';
import { ERROR_SNACKBAR } from '@nagel-types';
import { SnackbarService } from '../snackbarService/snackbar.service';


type HttpError = {
  error?: {
    title?: string;
    detail?: string;
  };
  message?: string;
};

@Injectable({
    providedIn: 'root'
})
export class ErrorHandleService {
    constructor(private snackBarService: SnackbarService) { }

    private getErrorMessage(e: HttpError): string {
        console.log(e);

        return e.error?.title ?? ''
            ? `${e.error?.title ?? ''} \n ${e.error?.detail ?? ''}`
            : e.message ?? '';
    }

    public showToasterError(e: HttpError, actionLabel?: string) {
        const message = this.getErrorMessage(e);

        this.snackBarService.pushSnackbar({
            message,
            action: actionLabel || 'Close',
            type: ERROR_SNACKBAR
        });
    }

    public logError(e: HttpError) {
        const message = this.getErrorMessage(e);

        console.log(message);
    }
}